import { URL } from '../../../variables'

export const SET_PROFIL = 'SET_PROFIL'
export const SET_MY_MEDICI = 'SET_MY_MEDICI'
export const SET_RID = 'SET_RID'
export default {
  [SET_PROFIL] (state, payload) {
    state.profil = []
    Object.values(payload).forEach(function (profilNode) {
      state.profil.push({
        uid: profilNode.uid[0].value,
        uuid: profilNode.uuid[0].value,
        username: profilNode.name[0].value,
        usermail: profilNode.mail[0].value,
        descriere: !(profilNode.field_descriere == '')
          ? profilNode.field_descriere[0].value
          : '',
        nr_medici: !(profilNode.field_numar_medici == '')
          ? profilNode.field_numar_medici[0].value
          : '0',
        nume: !(profilNode.field_nume == '')
          ? profilNode.field_nume[0].value
          : '',
        prenume: !(profilNode.field_prenume == '')
          ? profilNode.field_prenume[0].value
          : '',
        nume_cabinet: !(profilNode.field_nume_cabinet == '')
          ? profilNode.field_nume_cabinet[0].value
          : '',
        telefon: !(profilNode.field_telefon == '')
          ? profilNode.field_telefon[0].value
          : '',
        parinte_id: !(profilNode.field_user_parinte == '')
          ? profilNode.field_user_parinte[0].target_id
          : '',
        imagine_url: !(profilNode.user_picture == '')
          ? profilNode.user_picture[0].url
          : URL + '/images/no-img.jpg',
        imagine_id: !(profilNode.user_picture == '')
          ? profilNode.user_picture[0].target_id
          : '',
        imagine_uuid: !(profilNode.user_picture == '')
          ? profilNode.user_picture[0].target_uuid
          : '',
        adresa_id: !(profilNode.customer_profiles == '')
          ? profilNode.customer_profiles[0].target_id
          : '',
        servicii: !(profilNode.field_tipuri_de_servicii == '')
          ? profilNode.field_tipuri_de_servicii
          : '',
        tara: !(profilNode.field_tara == '')
          ? profilNode.field_tara[0].value
          : '',
        cod_postal: !(profilNode.field_cod_postal == '')
          ? profilNode.field_cod_postal[0].value
          : '',
        strada: !(profilNode.field_strada == '')
          ? profilNode.field_strada[0].value
          : '',
        localitate: !(profilNode.field_localitate == '')
          ? profilNode.field_localitate[0].value
          : '',
        numar_strada: !(profilNode.field_numar_strada == '')
          ? profilNode.field_numar_strada[0].value
          : '',
        judet: !(profilNode.field_judet == '')
          ? profilNode.field_judet[0].value
          : '',
        latitudine: !(profilNode.field_latitudine == '')
          ? profilNode.field_latitudine[0].value
          : '0',
        longitudine: !(profilNode.field_longitudine == '')
          ? profilNode.field_longitudine[0].value
          : '0'
      })
    })
  },
  [SET_MY_MEDICI] (state, payload) {
    state.mymedici = []
    Object.values(payload).forEach(function (mymediciNode) {
      state.mymedici.push({
        uid: mymediciNode.uid[0].value,
        email: mymediciNode.name[0].value,
        nume: !(mymediciNode.field_nume == '')
          ? mymediciNode.field_nume[0].value
          : '',
        prenume: !(mymediciNode.field_prenume == '')
          ? mymediciNode.field_prenume[0].value
          : '',
        fullnume: !(mymediciNode.field_nume == '')
          ? mymediciNode.field_nume[0].value + ' ' + mymediciNode.field_prenume[0].value
          : '',
        telefon: !(mymediciNode.field_telefon == '')
          ? mymediciNode.field_telefon[0].value
          : '-',
        medicBlock: !(mymediciNode.field_medic_dezactivat == '')
          ? mymediciNode.field_medic_dezactivat[0].value
          : false

      })
    })
  },
  [SET_RID] (state, payload) {
    state.rid = []
    Object.values(payload).forEach(function (ridNode) {
      state.rid.push({
        rid: !(ridNode) ? 'false' : 'true'
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profil/ProfilMutations.js